<template>
    <div class="flex-column" :class="{ 'record-list--participant': participantMode }" style="background-color:#fff;">
        <div class="flex-row-between padding-20-30 record-list__toolbar" v-if="showToolbar">
            <div class="flex-row">
                <span class="text-30-black">签到动态</span>
                <div @click="changeType('all')" class="choose-btn" :class="{ active: curTag == 'all' }">全部</div>
                <div @click="changeType('today')" class="choose-btn" :class="{ active: curTag == 'today' }">今天</div>
                <div @click="changeType('date')" class="choose-btn" :class="{ active: curTag == 'date' }">
                    {{ currentDateText ? currentDateText : '选择日期' }}</div>
                <div v-if="participantMode" @click="openStatus" class="choose-btn choose-btn--status"
                    :class="{ active: curTag == 'status' }">
                    {{ evalText ? evalText : '点评状态' }}
                </div>
            </div>
            <!-- 可以发布任务的签到，可以选择 -->
            <!-- <div class="flex-row" @click="showActionSheet">
                <span class="text-30-blue">全部签到</span>
                <img class="icon-30" src="@/assets/icon/ic_show_work.png" />
            </div> -->
        </div>
        <div class="record-list__divider" v-if="showToolbar"></div>
        <!-- 签到记录 -->
        <div class="list" v-if="records.length > 0">
            <div class="item" v-for="item in records" :key="item.pt_id">
                <!-- myrecord 模式与小程序保持一致：左侧显示日期徽章；普通模式显示头像。 -->
                <div v-if="isMyRecordMode" class="myrecord-left">{{ item.lastDateStr }}</div>
                <avatar v-else :adv_avatar="item.adv_avatar" :head_url="item.head_url" :size="36"></avatar>
                <!-- 右侧 -->
                <div class="flex-column" :class="{ 'left-10': !isMyRecordMode, 'myrecord-content': isMyRecordMode }" style="flex:1;">
                    <!-- 头部 -->
                    <div class="flex-row-between record-header" :class="{ 'record-header--myrecord': isMyRecordMode }"
                        :style="{ height: isMyRecordMode ? 'auto' : 36 * 3 / 75 + 'rem' }">
                        <div class="flex-column" style="justify-content:center;">
                            <div class="flex-row" v-if="!isMyRecordMode || item.stu_no || item.name || item.top">
                                <div class="stu-no" v-if="item.stu_no">{{ item.stu_no }}</div>
                                <div :style="{ color: item.name_color ? item.name_color : '' }" class="text-30-black">
                                    {{ item.name }}</div>
                                <img src="@/assets/icon/ic_top.png" v-if="item.top" class="top-img" />
                            </div>
                            <div class="flex-row top-10">
                                <span class="text-22-99">{{ item.date }}</span>
                                <img src="@/assets/icon/daiqian.png" v-if="item.is_agent == 1" class="icon-buqian" />
                                <img src="@/assets/icon/buqian.png" v-if="item.makeup == 1" class="icon-buqian" />
                            </div>
                        </div>
                        <div>
                            <!-- <img class="icon-edit" src="@/assets/icon/ic_edit.png" />
                            <span class="text-22-99">编辑</span> -->
                        </div>
                    </div>

                    <!-- 内容 -->
                    <div class="flex-column">
                        <div v-if="item.is_audit == 0">
                            <div v-for="(fill_param, fillParamIndex) in item.fill_params" :key="fillParamIndex">
                                <div class="checkin-text"
                                    v-if="fill_param.key > 8 && fill_param.key != 100 && !isSignParam(fill_param)">
                                    {{ fill_param.name }}：{{ fill_param.val }}</div>
                            </div>
                        </div>

                        <div class="checkin-text" v-if="item.is_audit == 1">签到内容正在审核中，审核通过后会自动展示</div>
                        <div class="checkin-text" v-if="item.is_audit == 2">签到内容违规，已被隐藏</div>

                        <div class="flex-column" v-for="(fill_param, fillParamIndex) in item.fill_params"
                            :key="fillParamIndex">
                            <!-- 文字 -->
                            <div class="checkin-text" v-if="fill_param.key == 1 && fill_param.val && item.is_audit == 0"
                                :style="{ color: item.text_color }">{{ fill_param.val }}</div>
                            <!-- 图片 -->
                            <comment-pic v-if="fill_param.key == 2 && fill_param.val && fill_param.val.length > 0"
                                :urls="fill_param.val"></comment-pic>
                            <comment-pic v-if="fill_param.key == 100 && fill_param.val && fill_param.val.length > 0"
                                :urls="fill_param.val"></comment-pic>
                            <!-- 视频 -->
                            <div class="video-list" v-if="fill_param.key == 3 && getVideoList(fill_param.val).length > 0">
                                <video-box class="video-item" v-for="(video, videoIndex) in getVideoList(fill_param.val)"
                                    :key="`${item.pt_id}-video-${fillParamIndex}-${videoIndex}`"
                                    :thumb="getVideoThumb(video)"
                                    :url="getVideoUrl(video)"></video-box>
                            </div>
                            <!-- 音频 -->
                            <div class="audio-list" v-if="fill_param.key == 4 && getAudioList(fill_param.val).length > 0">
                                <div class="audio-item" v-for="(audio, audioIndex) in getAudioList(fill_param.val)"
                                    :key="getAudioKey('main', item.pt_id, fillParamIndex, audioIndex)">
                                    <div @click="playAudio(audio.url, item.pt_id, getAudioKey('main', item.pt_id, fillParamIndex, audioIndex))"
                                        class="audio-box">
                                        <img class="audio-img" src="@/assets/icon/audio.png" />
                                        <span class="audio-duration">{{ getAudioDuration(audio) }}″</span>
                                    </div>
                                    <audio class="audio-inline"
                                        v-if="showAudioPlayer && pt_id == item.pt_id && activeAudioKey == getAudioKey('main', item.pt_id, fillParamIndex, audioIndex)"
                                        controls :src="audioSrc" autoplay />
                                </div>
                            </div>
                            <!-- 文件 -->
                            <div v-if="fill_param.key == 5 && getFileList(fill_param.val).length > 0">
                                <open-document class="top-20"
                                    v-for="(fileItem, fileIndex) in getFileList(fill_param.val)"
                                    :key="`${item.pt_id}-file-${fillParamIndex}-${fileIndex}`"
                                    :file_name="fileItem.name" :file_url="fileItem.url"></open-document>
                            </div>
                            <!-- 地址 -->
                            <div class="address-box top-20" v-if="fill_param.key == 6 && getAddressText(fill_param.val)">
                                <img class="address-icon" src="@/assets/icon/address_add.png" />
                                <span class="address-text">{{ getAddressText(fill_param.val) }}</span>
                            </div>
                            <!-- 手写签名 -->
                            <comment-pic v-if="isSignParam(fill_param) && getSignUrls(fill_param.val).length > 0"
                                :urls="getSignUrls(fill_param.val)"></comment-pic>
                            <!-- 微信步数 -->
                            <div v-if="fill_param.key == 7 && fill_param.val != -1">
                                <span class="step-box" v-if="fill_param.val == -2">
                                    <span class="step-text">该设备不支持计步</span>
                                </span>
                                <div class="step-box" v-else>
                                    <div class="step-box-content">
                                        <img class="step-icon" src="@/assets/icon/ic_run.png" />
                                        <span class="step-text"> 打卡步数 {{ fill_param.val }}</span>
                                    </div>
                                </div>
                            </div>
                            <!-- 微信文章 -->
                            <article-box v-if="fill_param.key == 8 && fill_param.val" :mp_icon="fill_param.val.mp_icon"
                                :mp_url="fill_param.val.mp_url" :mp_title="fill_param.val.mp_title"></article-box>
                        </div>
                        <!-- 修正内容 -->
                        <div class="flex-column" v-if="item.fix.date">
                            <span class="text-28-33">------订正如下------</span>
                            <span class="checkin-time">{{ item.fix.date }}</span>
                            <div v-for="(fill_param, fillParamIndex) in item.fix.fill_params" :key="fillParamIndex">
                                <!-- 文字 -->
                                <div :style="{ color: fill_param.text_color }" class="checkin-text"
                                    v-if="fill_param.key > 8 && fill_param.key != 100 && !isSignParam(fill_param)">
                                    {{ fill_param.name }}：{{ fill_param.val }}</div>
                                <div :style="{ color: fill_param.text_color }" class="checkin-text"
                                    v-if="fill_param.key == 1 && fill_param.val">{{ fill_param.val }}</div>
                                <!-- 图片 -->
                                <comment-pic v-if="fill_param.key == 2 && fill_param.val.length > 0"
                                    :urls="fill_param.val"></comment-pic>
                                <comment-pic v-if="fill_param.key == 100 && fill_param.val && fill_param.val.length > 0"
                                    :urls="fill_param.val"></comment-pic>
                                <!-- 视频 -->
                                <div class="video-list" v-if="fill_param.key == 3 && getVideoList(fill_param.val).length > 0">
                                    <video-box class="video-item" v-for="(video, videoIndex) in getVideoList(fill_param.val)"
                                        :key="`${item.pt_id}-fix-video-${fillParamIndex}-${videoIndex}`"
                                        :thumb="getVideoThumb(video)"
                                        :url="getVideoUrl(video)"></video-box>
                                </div>
                                <!-- 音频 -->
                                <div class="audio-list" v-if="fill_param.key == 4 && getAudioList(fill_param.val).length > 0">
                                    <div class="audio-item" v-for="(audio, audioIndex) in getAudioList(fill_param.val)"
                                        :key="getAudioKey('fix', item.pt_id, fillParamIndex, audioIndex)">
                                        <div @click="playAudio(audio.url, item.pt_id, getAudioKey('fix', item.pt_id, fillParamIndex, audioIndex))"
                                            class="audio-box">
                                            <img class="audio-img" src="@/assets/icon/audio.png" />
                                            <span class="audio-duration">{{ getAudioDuration(audio) }}″</span>
                                        </div>
                                        <audio class="audio-inline"
                                            v-if="showAudioPlayer && pt_id == item.pt_id && activeAudioKey == getAudioKey('fix', item.pt_id, fillParamIndex, audioIndex)"
                                            controls :src="audioSrc" autoplay />
                                    </div>
                                </div>
                                <!-- 文件 -->
                                <div v-if="fill_param.key == 5 && getFileList(fill_param.val).length > 0">
                                    <open-document class="top-20"
                                        v-for="(fileItem, fileIndex) in getFileList(fill_param.val)"
                                        :key="`${item.pt_id}-fix-file-${fillParamIndex}-${fileIndex}`"
                                        :file_name="fileItem.name" :file_url="fileItem.url"></open-document>
                                </div>
                                <!-- 地址 -->
                                <div class="address-box top-20" v-if="fill_param.key == 6 && getAddressText(fill_param.val)">
                                    <img class="address-icon" src="@/assets/icon/address_add.png" />
                                    <span class="address-text">{{ getAddressText(fill_param.val) }}</span>
                                </div>
                                <!-- 手写签名 -->
                                <comment-pic v-if="isSignParam(fill_param) && getSignUrls(fill_param.val).length > 0"
                                    :urls="getSignUrls(fill_param.val)"></comment-pic>
                                <!-- 微信步数 -->
                                <div v-if="fill_param.key == 7 && fill_param.val != -1">
                                    <span class="step-box" v-if="fill_param.val == -2">
                                        <span class="step-text">该设备不支持计步</span>
                                    </span>
                                    <div class="step-box" v-else>
                                        <div class="step-box-content">
                                            <img class="step-icon" src="@/assets/icon/ic_run.png" />
                                            <span class="step-text"> 打卡步数 {{ fill_param.val }}</span>
                                        </div>
                                    </div>
                                </div>
                                <!-- 微信文章 -->
                                <article-box v-if="fill_param.key == 8 && fill_param.val"
                                    :mp_icon="fill_param.val.mp_icon" :mp_url="fill_param.val.mp_url"
                                    :mp_title="fill_param.val.mp_title"></article-box>
                            </div>
                        </div>

                    </div>
                    <!-- 底部 -->
                    <div class="flex-row-between top-20 record-actions" style="flex:1;" v-if="!isMyRecordMode && checkin && checkin.template != 1">
                        <div class="flex-row record-actions__left">
                            <div class="flex-row right-10 record-action-entry" v-if="checkin.no_com == 0">
                                <img class="icon-40"
                                    src="https://cdn-xcxcustom.weiyoubot.cn/20210625/a05aa09455c8887a49485be3040116ac.png" />
                                <span class="text-28-99">评论</span>
                                <wx-launch-weapp-trigger
                                    :enabled="canLaunchRecordActionByWxTag"
                                    :path="recordCommentPath"
                                    template-width="86px"
                                    template-height="40px"
                                    @click="showDialog"></wx-launch-weapp-trigger>
                            </div>
                            <div class="flex-row right-10 record-action-entry"
                                v-if="checkin.no_forward == 0 || (checkin.no_forward == 1 && checkin.is_owner)">
                                <img class="icon-40"
                                    src="https://cdn-xcxcustom.weiyoubot.cn/20210624/d8b2f7df6d0885d2f0c9de75edb0becc.png" />
                                <span class="text-28-99">分享</span>
                                <wx-launch-weapp-trigger
                                    :enabled="canLaunchRecordActionByWxTag"
                                    :path="recordSharePath"
                                    template-width="86px"
                                    template-height="40px"
                                    @click="showDialog"></wx-launch-weapp-trigger>
                            </div>
                            <div class="flex-row right-10 record-action-entry" v-if="!participantMode">
                                <img class="icon-40"
                                    src="https://cdn-xcxcustom.weiyoubot.cn/20210624/b2392fecc135826a09c34adf5b6f88bd.png" />
                                <span class="text-28-99">详情</span>
                                <wx-launch-weapp-trigger
                                    :enabled="canLaunchRecordActionByWxTag"
                                    :path="recordDetailPath"
                                    template-width="86px"
                                    template-height="40px"
                                    @click="showDialog"></wx-launch-weapp-trigger>
                            </div>
                            <div class="flex-row right-10 record-action-entry"
                                v-if="!participantMode && (checkin.is_owner == 1 || checkin.is_admin == 1)">
                                <img class="icon-40"
                                    src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220414/946da378b3782dcf917b0a021f92a409.svg" />
                                <span class="text-28-99">点评</span>
                                <wx-launch-weapp-trigger
                                    :enabled="canLaunchRecordActionByWxTag"
                                    :path="recordReviewPath"
                                    template-width="86px"
                                    template-height="40px"
                                    @click="showDialog"></wx-launch-weapp-trigger>
                            </div>
                        </div>
                        <div @click="toggleLike(item)" class="flex-row record-actions__like">
                            <img class="like-img"
                                :src="getLikeStatus(item) == 1 ? 'https://cdn-xcxcustom.weiyoubot.cn/20210624/c16e92e3db9fcafd40c52282e6803d69.png' : 'https://cdn-xcxcustom.weiyoubot.cn/20210624/70caf25d8ec30da772cbbf1055d2a592.png'" />
                            <span class="like-text">{{ getLikeCount(item) }}</span>
                        </div>
                    </div>
                    <!-- 点评详情 -->
                    <div class="remark-list" v-if="item.remarks && item.remarks.length > 0">
                        <div class="remark" v-for="(remark, remarkIndex) in item.remarks" :key="remarkIndex">
                            <span class="remark-name">{{ remark.nickname }}</span>
                            <span class="remark-time">{{ remark.t_submit }}</span>
                            <van-rate class="top-10" color="#ffd21e" :count="6" readonly v-model="remark.rank" />
                            <div class="remark-content">{{ remark.content }}</div>
                            <comment-pic :urls="remark.imgs"></comment-pic>
                            <!-- 点评声音 -->
                            <div class="audio-item" v-if="remark.audio">
                                <div @click="playAudio(remark.audio.audioUrl, item.pt_id, getAudioKey('remark', item.pt_id, remarkIndex, 0))"
                                    class="audio-box">
                                    <img class="audio-img" src="@/assets/icon/audio.png" />
                                    <span class="audio-duration">{{ remark.audio.duration }}″</span>
                                </div>
                                <audio class="audio-inline"
                                    v-if="showAudioPlayer && pt_id == item.pt_id && activeAudioKey == getAudioKey('remark', item.pt_id, remarkIndex, 0)"
                                    controls :src="audioSrc" autoplay />
                            </div>
                            <!-- 点评印章 -->
                            <img class="remark-img" v-if="remark.rank == 6" src="@/assets/icon/A+.png" />
                            <img class="remark-img" v-if="remark.rank == 5" src="@/assets/icon/A.png" />
                            <img class="remark-img" v-if="remark.rank == 4" src="@/assets/icon/B.png" />
                            <img class="remark-img" v-if="remark.rank == 3" src="@/assets/icon/C.png" />
                            <img class="remark-img" v-if="remark.rank == 2" src="@/assets/icon/D.png" />
                            <img class="remark-img" v-if="remark.rank == 1" src="@/assets/icon/need_change.png" />
                        </div>
                    </div>
                    <!-- 评论详情 -->
                    <div class="comment-list" v-if="item.comments.length > 0">
                        <div v-for="(comment, commentIndex) in item.comments" :key="commentIndex">
                            <div class="flex-column" v-if="commentIndex < 6">
                                <div class="flex-row">
                                    <span class="comment-item-text">{{ comment.nickname }} {{ comment.reply_to.length > 0
                                        ? '回复'+ comment.reply_to : ''}}：</span>
                                    <div class="comment-item-text comment-item-content">{{ formatCommentContent(comment.content) }}</div>
                                </div>
                                <div class="audio-item" v-if="comment.audio">
                                    <div class="audio-box"
                                        @click="playAudio(comment.audio.audioUrl, item.pt_id, getAudioKey('comment', item.pt_id, commentIndex, 0))">
                                        <img class="audio-img" src="@/assets/icon/audio.png" />
                                        <span class="audio-duration">{{ comment.audio.duration }}″</span>
                                    </div>
                                    <audio class="audio-inline"
                                        v-if="showAudioPlayer && pt_id == item.pt_id && activeAudioKey == getAudioKey('comment', item.pt_id, commentIndex, 0)"
                                        controls :src="audioSrc" autoplay />
                                </div>
                            </div>
                        </div>
                        <span @click="showDialog" v-if="item.comments.length > 6"
                            class="look-all-comment">点击查看所有评论</span>
                    </div>
                    <!-- myrecord 模式下来源入口放在点评/评论之后，与小程序展示顺序保持一致。 -->
                    <div class="myrecord-action" v-if="isMyRecordMode">
                        <div class="from">来自：{{ item.title || '-' }}</div>
                        <div class="blue" @click.stop="toDetailFromMyRecord(item)">进入签到</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 空布局 -->
        <div class="empty-box" v-if="records.length == 0">
            <img class="empty-img" src="https://cdn-xcxcustom.weiyoubot.cn/20210308/ccc979e23a23fda7baee0d9640c1334f.png" />
            <span class="empty-text">暂无内容 ~</span>
        </div>

        <!-- 日期选择器 -->
        <van-popup :close-on-click-overlay="false" v-model="showDatePicker" position="bottom" class="record-date-popup"
            style="width: 100%; max-width: 500px; left: 0; right: 0; margin: 0 auto;">
            <van-datetime-picker type="date" v-model="pickerDate" @cancel="cancel"
                @confirm="setCurrentDate"></van-datetime-picker>
        </van-popup>
        <van-popup v-model="showEvalDialog" position="bottom" class="eval-dialog-popup"
            style="width: 100%; max-width: 500px; left: 0; right: 0; margin: 0 auto;">
            <div class="eval-dialog">
                <div class="eval-title">请选择点评状态</div>
                <div class="eval-levels">
                    <div class="level-btn" :class="{ active: evalLevel == item.value }" v-for="item in leverList"
                        :key="item.value" @click="changeStatus(item.value)">
                        {{ item.label }}
                    </div>
                </div>
                <div class="eval-actions">
                    <div class="btn-cancel" @click="closeEvalDialog">取消</div>
                    <div class="btn-confirm" @click="confirmEvalDialog">确定</div>
                </div>
            </div>
        </van-popup>
        <!-- 前往小程序 -->
        <mini-dialog :cid="checkin && checkin.cid ? checkin.cid : ''" message="该功能不支持在H5中使用，请前往小程序使用该功能" @close="showMini = false"
            :showMini="showMini"></mini-dialog>
    </div>
</template>
<script>
import { formatDate, getToken, getUTCDateInSeconds, getDaysLater, getPc, getAndroidMiniPath, tryLaunchMiniProgramOnPc } from '@/utils/common'
import api from '@/utils/api'
import http from "@/utils/http";
import Avatar from '@/components/Avatar.vue';
import CommentPic from '@/components/CommentPic.vue';
import OpenDocument from '@/components/OpenDocument.vue';
import VideoBox from '@/components/VideoBox.vue';
import ArticleBox from '@/components/ArticleBox.vue';
import MiniDialog from '@/components/MiniDialog.vue';
import WxLaunchWeappTrigger from '@/components/WxLaunchWeappTrigger.vue';


export default {
    components: { Avatar, CommentPic, OpenDocument, VideoBox, ArticleBox, MiniDialog, WxLaunchWeappTrigger },
    name: 'RecordList',
    props: {
        checkin: {
            type: Object,
            default: null
        },
        hasUserInfo: {
            type: Boolean,
            default: false
        },
        unionid: {
            type: String,
            default: ''
        },
        source: {
            type: String,
            default: ''
        },
        showToolbar: {
            type: Boolean,
            default: true
        },
        participantMode: {
            type: Boolean,
            default: false
        },
        startTime: {
            type: Number,
            default: 0
        },
        endTime: {
            type: Number,
            default: 0
        },
        workId: {
            type: [String, Number],
            default: ''
        },
        direction: {
            type: Number,
            default: 0
        },
        reviewFilter: {
            type: String,
            default: ''
        }
    },
    data: () => {
        return {
            curTag: 'all', //当前的类型 all today date
            records: [],
            showDatePicker: false, //是否显示日期选择器
            currentDate: '', //当前日期
            pickerDate: '', // 日期选择起的日期
            page: 1, // 分页
            count: 20,
            view_type: 0, // 全部 普通 任务
            max_id: '',
            start: 0,
            end: 0,

            pt_id: '',
            showAudioPlayer: false,
            audioSrc: '',
            activeAudioKey: '',

            showMini: false, //是否显示小程序弹窗
            likeLoadingMap: {},
            showEvalDialog: false,
            evalLevel: '',
            evalText: '',
            leverList: [
                { label: 'A', value: '5' },
                { label: 'B', value: '4' },
                { label: 'C', value: '3' },
                { label: 'D', value: '2' },
                { label: '优秀作业', value: '6' },
                { label: '需订正', value: '1' },
                { label: '已点评', value: '11' },
                { label: '未点评', value: '10' },
            ],
            loadedCid: '',
        }
    },
    computed: {
        currentDateText() {
            if (this.currentDate == '') {
                return ''
            } else {
                return formatDate(this.currentDate, 'yyyy-MM-dd')
            }
        },
        canLaunchRecordActionByWxTag() {
            const pcType = getPc()
            return this.hasUserInfo && (pcType == 2 || pcType == 3) && !!this.checkin && !!this.checkin.cid
        },
        recordActionBasePath() {
            if (!this.checkin || !this.checkin.cid) {
                return ''
            }
            // 统一复用签到详情小程序路径，entry 仅用于标记入口来源，便于小程序侧后续扩展。
            return getAndroidMiniPath(this.checkin.template, this.checkin.cid)
        },
        recordCommentPath() {
            if (!this.recordActionBasePath) {
                return ''
            }
            return `${this.recordActionBasePath}&entry=comment`
        },
        recordSharePath() {
            if (!this.recordActionBasePath) {
                return ''
            }
            return `${this.recordActionBasePath}&entry=share`
        },
        recordDetailPath() {
            if (!this.recordActionBasePath) {
                return ''
            }
            return `${this.recordActionBasePath}&entry=detail`
        },
        recordReviewPath() {
            if (!this.recordActionBasePath) {
                return ''
            }
            return `${this.recordActionBasePath}&entry=review`
        },
        isMyRecordMode() {
            return this.source === 'myrecord'
        }
    },
    watch: {
        checkin: {
            immediate: true,
            handler(val) {
                if (this.isMyRecordMode) {
                    this.resetFiltersToDefault()
                    this.resetAndFetch()
                    return
                }
                const cid = val && val.cid ? val.cid : ''
                if (!cid || cid == this.loadedCid) {
                    return
                }
                this.loadedCid = cid
                // 切换到新的签到后，回到默认“全部”筛选，避免沿用上一个签到的筛选条件。
                this.resetFiltersToDefault()
                this.resetAndFetch()
            }
        },
        unionid() {
            this.resetAndFetch()
        },
        startTime() {
            if (!this.showToolbar) {
                this.resetAndFetch()
            }
        },
        endTime() {
            if (!this.showToolbar) {
                this.resetAndFetch()
            }
        },
        workId() {
            this.resetAndFetch()
        },
        direction() {
            this.resetAndFetch()
        },
        reviewFilter() {
            if (!this.showToolbar) {
                this.resetAndFetch()
            }
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        ensureArray(val) {
            if (Array.isArray(val)) {
                return val
            }
            if (val === null || val === undefined || val === '') {
                return []
            }
            return [val]
        },
        getVideoList(val) {
            return this.ensureArray(val).filter(item => {
                if (!item) return false
                if (typeof item === 'string') return !!item.trim()
                return !!this.getVideoUrl(item)
            })
        },
        getVideoUrl(video) {
            if (!video) return ''
            if (typeof video === 'string') return video
            return video.url || video.video_url || video.src || ''
        },
        getVideoThumb(video) {
            if (!video) return ''
            if (typeof video === 'string') return ''
            return video.thumb || video.cover || video.poster || video.url || ''
        },
        getAudioList(val) {
            return this.ensureArray(val).filter(item => {
                if (!item) return false
                if (typeof item === 'string') return true
                return !!(item.url || item.audioUrl || item.src)
            }).map(item => {
                if (typeof item === 'string') {
                    return { url: item, len: 0 }
                }
                return item
            })
        },
        getAudioDuration(audio) {
            if (!audio || typeof audio === 'string') return 0
            return Number(audio.len || audio.duration || audio.audio_len || 0)
        },
        getFileList(val) {
            return this.ensureArray(val).filter(item => {
                if (!item) return false
                if (typeof item === 'string') return true
                return !!(item.url || item.file_url || item.path)
            }).map(item => {
                if (typeof item === 'string') {
                    return {
                        name: this.getFileNameFromUrl(item),
                        url: item,
                    }
                }
                return {
                    name: item.name || this.getFileNameFromUrl(item.url || item.file_url || item.path || ''),
                    url: item.url || item.file_url || item.path || '',
                }
            })
        },
        getFileNameFromUrl(url = '') {
            if (!url) return '文件'
            const cleanUrl = String(url).split('?')[0]
            const parts = cleanUrl.split('/')
            return decodeURIComponent(parts[parts.length - 1] || '文件')
        },
        getAddressText(val) {
            if (!val) return ''
            if (typeof val === 'string') return val
            if (typeof val === 'object') {
                return val.address || val.name || val.text || ''
            }
            return ''
        },
        isSignParam(fillParam) {
            if (!fillParam) return false
            return Number(fillParam.key) === 11 || Number(fillParam.field_type) === 10
        },
        getSignUrls(val) {
            return this.ensureArray(val).filter(item => !!item).map(item => {
                if (typeof item === 'string') return item
                return item.url || item.src || ''
            }).filter(url => !!url)
        },
        // 生成 myrecord 左侧日期徽章，接口 date 异常时返回空串避免渲染 NaN。
        getRecordDayText(timestamp) {
            const date = new Date(Number(timestamp) * 1000)
            if (Number.isNaN(date.getTime())) {
                return ''
            }
            return formatDate(date, 'dd')
        },
        // 进入记录所属签到活动详情，保持小程序 myRecordToDetail 的跳转语义。
        toDetailFromMyRecord(item) {
            if (!item || !item.cid) {
                return
            }
            this.$router.push({
                name: 'detail',
                query: {
                    cid: item.cid,
                },
            })
        },
        // 恢复到默认筛选：全部记录、无日期筛选、无点评状态筛选。
        resetFiltersToDefault() {
            this.curTag = 'all'
            this.currentDate = ''
            this.start = 0
            this.end = 0
            this.evalText = ''
            this.evalLevel = ''
        },
        handleScroll() {
            // 到达底部附近时触发下一页加载；当当前总数不足 page*count 说明已经没有更多了。
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
            const windowHeight = document.documentElement.clientHeight || document.body.clientHeight
            const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
            if (scrollTop + windowHeight <= scrollHeight - 60) {
                return
            }
            if (this.records.length < this.page * this.count) {
                return
            }
            this.page++
            this.getRecordsList()
        },
        changeType(type) {
            if (type == 'date') {
                if (this.currentDate == '') {
                    this.pickerDate = new Date()
                } else {
                    this.pickerDate = this.currentDate
                }
                this.showDatePicker = true
            } else {
                if (this.curTag == type) {
                    return
                }
                this.curTag = type
                this.evalText = ''
                this.evalLevel = ''
                if (this.curTag == 'today') {
                    this.start = getUTCDateInSeconds(formatDate(getDaysLater(0), 'yyyy-MM-dd'))
                    this.end = getUTCDateInSeconds(formatDate(getDaysLater(1), 'yyyy-MM-dd')) - 1
                } else {
                    this.start = 0
                    this.end = 0
                }
                this.max_id = ''
                this.page = 1;
                this.getRecordsList()
            }
        },
        setCurrentDate(date) {
            this.showDatePicker = false
            this.pickerDate = date
            this.currentDate = date
            this.curTag = 'date'
            this.evalText = ''
            this.evalLevel = ''
            this.start = getUTCDateInSeconds(formatDate(this.currentDate, 'yyyy-MM-dd'))
            this.end = getUTCDateInSeconds(formatDate(this.currentDate, 'yyyy-MM-dd')) + 24 * 3600 - 1
            this.max_id = ''
            this.page = 1;
            this.getRecordsList()
        },
        cancel() {
            this.showDatePicker = false
        },
        openStatus() {
            this.showEvalDialog = true
        },
        changeStatus(value) {
            this.evalLevel = value
        },
        closeEvalDialog() {
            this.showEvalDialog = false
        },
        confirmEvalDialog() {
            if (!this.evalLevel) {
                this.showEvalDialog = false
                return
            }
            const target = this.leverList.find(item => item.value == this.evalLevel)
            this.evalText = target ? target.label : ''
            this.curTag = 'status'
            this.showEvalDialog = false
            this.max_id = ''
            this.page = 1
            this.getRecordsList()
        },
        getAudioKey(type, ptId, firstIndex, secondIndex) {
            return `${type}-${ptId}-${firstIndex}-${secondIndex}`
        },
        playAudio(audio, pt_id, audioKey) {
            if (audio) {
                this.pt_id = pt_id
                this.showAudioPlayer = true
                this.audioSrc = audio
                this.activeAudioKey = audioKey || ''
            }
        },
        // 列表接口在不同端返回的点赞字段存在差异：
        // - like 可能是“我是否点赞(0/1)”，也可能是“点赞总数”
        // - like_count / like_num / like_total 可能存在其一
        // 这里统一为 like_status(是否点赞) 与 like_count(数量)，后续 UI 与交互只用这两个字段。
        normalizeLikeInfo(item) {
            if (!item) {
                return
            }
            const rawLike = Number(item.like)
            const statusSource = item.like_status !== undefined
                ? item.like_status
                : (item.is_like !== undefined ? item.is_like : item.has_liked)
            const countSource = item.like_count !== undefined
                ? item.like_count
                : (item.like_num !== undefined ? item.like_num : item.like_total)
            const rawStatus = Number(statusSource)
            const rawCount = Number(countSource)
            let likeStatus = 0
            let likeCount = 0
            if (rawStatus === 0 || rawStatus === 1) {
                likeStatus = rawStatus
            } else if (rawLike === 0 || rawLike === 1) {
                likeStatus = rawLike
            }
            if (Number.isFinite(rawCount)) {
                likeCount = Math.max(0, rawCount)
            } else if (Number.isFinite(rawLike)) {
                likeCount = Math.max(0, rawLike)
            }
            item.like_status = likeStatus
            item.like_count = likeCount
        },
        getLikeStatus(item) {
            if (!item) {
                return 0
            }
            return Number(item.like_status) === 1 ? 1 : 0
        },
        getLikeCount(item) {
            if (!item) {
                return 0
            }
            const likeCount = Number(item.like_count)
            return Number.isFinite(likeCount) && likeCount >= 0 ? likeCount : 0
        },
        formatCommentContent(content) {
            if (content === null || content === undefined) {
                return ''
            }
            return String(content)
                .replace(/\\n/g, '\n')
                .replace(/\/n/g, '\n')
        },
        toggleLike(item) {
            if (!item || !item.pt_id) {
                return
            }
            const key = String(item.pt_id)
            if (this.likeLoadingMap[key]) {
                return
            }
            const prevLike = this.getLikeStatus(item)
            const prevCount = this.getLikeCount(item)
            const nextLike = prevLike === 1 ? 0 : 1
            // 先更新本地视觉反馈，接口失败时再回滚，避免点击后没有反馈。
            item.like_status = nextLike
            item.like_count = Math.max(0, prevCount + (nextLike === 1 ? 1 : -1))
            this.$set(this.likeLoadingMap, key, true)
            http
                .post('/xcx/checkin/v3/like', {
                    access_token: getToken(),
                    pt_id: item.pt_id,
                    like: nextLike,
                })
                .then(() => {
                    this.$set(this.likeLoadingMap, key, false)
                })
                .catch(() => {
                    item.like_status = prevLike
                    item.like_count = prevCount
                    this.$set(this.likeLoadingMap, key, false)
                })
        },
        // 获取签到动态
        getRecordsList() {
            if (this.isMyRecordMode) {
                this.getPersonalRecordsList()
                return
            }
            if (!this.checkin || !this.checkin.cid) {
                return
            }
            const start = this.showToolbar ? (this.start || 0) : (this.startTime || 0)
            const end = this.showToolbar ? (this.end || 0) : (this.endTime || 0)
            // 参数组装遵循“显式筛选优先”原则：
            // 1) 日期/今天筛选通过 start/end 控制
            // 2) 指定 unionid 优先，其次按权限自动降级为仅看自己的记录
            // 3) 点评状态映射到 rank/has_graded
            let params = {
                cid: this.checkin.cid,
                sort_type: 0,
                page: this.page,
                count: this.count,
                start,
                end,
                access_token: getToken(),
                view_type: this.view_type,
                max_id: this.max_id
            }
            const wid = this.workId || (this.checkin && this.checkin.wid) || ''
            if (wid) {
                params.wid = wid
            }
            if (this.direction === 0 || this.direction === 1) {
                params.direction = this.direction
            }
            if (this.source) {
                params.source = this.source
            }
            if (this.unionid) {
                params.unionid = this.unionid
            } else if (this.checkin.permiss == 1 && this.checkin.is_owner == 0 && this.checkin.is_admin == 0) {
                params.unionid = this.checkin.unionid
            }
            if (this.curTag == 'status' && this.evalLevel) {
                if (this.evalLevel == '10') {
                    params.has_graded = 0
                } else if (this.evalLevel == '11') {
                    params.has_graded = 1
                } else {
                    params.rank = Number(this.evalLevel)
                }
            }
            if (!this.showToolbar && this.reviewFilter) {
                if (this.reviewFilter == '10') {
                    params.has_graded = 0
                } else if (this.reviewFilter == '11') {
                    params.has_graded = 1
                } else {
                    params.rank = Number(this.reviewFilter)
                }
            }

            http.get('/xcx/checkin/v3/pic_text', params).then(res => {
                let records = res.data
                for (let i = 0; i < records.length; i++) {
                    let record = records[i]
                    record.date = formatDate(new Date(record.date * 1000), 'yyyy-MM-dd HH:mm:ss')
                    if (typeof record.pic == 'string') {
                        record.pic = record.pic ? [record.pic] : []
                    }
                    if (record.fix && record.fix.date) {
                        record.fix.date = formatDate(new Date(record.fix.date * 1000), 'yyyy-MM-dd HH:mm:ss')
                    }
                    if (!record.head_url) {
                        record.head_url = '@/assets/icon/default_avatar.png'
                    }
                    this.normalizeLikeInfo(record)
                    if (record.remarks && record.remarks.length > 0) {
                        let remarks = record.remarks
                        for (let j = 0; j < remarks.length; j++) {
                            remarks[j].t_submit = formatDate(new Date(remarks[j].t_submit * 1000), 'yyyy-MM-dd HH:mm:ss')
                        }
                    }
                }

                this.max_id = res.max_id || ''
                this.records = this.page == 1 ? records : this.records.concat(records)
                this.$forceUpdate();
            })
        },
        // 获取个人中心“签到记录”列表，接口与小程序 /subPages/pages/myrecord/myrecord 保持一致。
        getPersonalRecordsList() {
            const params = {
                page: this.page,
                count: this.count,
                start: this.start || 0,
                end: this.end || 0,
                access_token: getToken(),
            }
            http.get(api.checkin.personalRecords, params).then(res => {
                const payload = res && res.data ? res.data : {}
                const records = Array.isArray(payload.records) ? payload.records : []
                for (let i = 0; i < records.length; i++) {
                    const record = records[i]
                    record.lastDateStr = this.getRecordDayText(record.date)
                    record.date = formatDate(new Date(Number(record.date) * 1000), 'yyyy-MM-dd HH:mm:ss')
                    if (typeof record.pic == 'string') {
                        record.pic = record.pic ? [record.pic] : []
                    }
                    if (record.fix && record.fix.date) {
                        record.fix.date = formatDate(new Date(Number(record.fix.date) * 1000), 'yyyy-MM-dd HH:mm:ss')
                    }
                    if (!record.head_url) {
                        record.head_url = '@/assets/icon/default_avatar.png'
                    }
                    this.normalizeLikeInfo(record)
                    if (record.remarks && record.remarks.length > 0) {
                        const remarks = record.remarks
                        for (let j = 0; j < remarks.length; j++) {
                            remarks[j].t_submit = formatDate(new Date(Number(remarks[j].t_submit) * 1000), 'yyyy-MM-dd HH:mm:ss')
                        }
                    }
                }
                this.$emit('personal-record-stats', {
                    joined: Number(payload.joined || 0),
                    submited: Number(payload.submited || 0),
                })
                this.records = this.page == 1 ? records : this.records.concat(records)
            })
        },
        // 提示
        showDialog() {
            tryLaunchMiniProgramOnPc({
                path: this.recordActionBasePath,
            }).then((state) => {
                if (state && state.launched) {
                    return
                }
                this.showMini = true
            }).catch(() => {
                this.showMini = true
            })
        },
        resetAndFetch() {
            if (!this.isMyRecordMode && (!this.checkin || !this.checkin.cid)) {
                return
            }
            this.page = 1
            this.max_id = ''
            this.records = []
            this.getRecordsList()
        }
    }
}
</script>
<style lang="scss" scoped>
@function rem($px) {
    @return $px / 75+rem;
}

.record-list__toolbar {
    align-items: center;
}

.record-list__divider {
    width: 100%;
    height: 1px;
    background-color: #eee;
}

.list {
    display: flex;
    flex-direction: column;
    padding: rem(20) rem(20);
    box-sizing: border-box;
}

.item {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    margin-bottom: rem(28);
}

.myrecord-left {
    width: rem(80);
    height: rem(80);
    margin: 0 rem(20) 0 0;
    flex: 0 0 rem(80);
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url('https://cdn-xcx-qunsou.weiyoubot.cn/material/2022-11-07/dce52358ba3a04905a74931f77fe2406.svg');
    background-size: 100% 100%;
    color: #fff;
    font-size: rem(40);
    font-weight: 700;
}

.myrecord-content {
    min-width: 0;
}

.record-header--myrecord {
    align-items: flex-start;
}

.myrecord-action {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-top: rem(18);
}

.myrecord-action .from {
    max-width: rem(480);
    overflow: hidden;
    color: #262626;
    font-size: rem(28);
    font-weight: 700;
    line-height: rem(40);
    text-overflow: ellipsis;
    white-space: nowrap;
}

.myrecord-action .blue {
    flex: 0 0 auto;
    margin-left: rem(20);
    color: #12b7f5;
    font-size: rem(28);
    line-height: rem(40);
    cursor: pointer;
}

.text-30-black {
    font-size: rem(30);
    color: #000;
}

.text-28-99 {
    font-size: rem(28);
    color: #999;
}

.text-30-blue {
    font-size: rem(30);
    color: #12b7f5;
}

.icon-30 {
    width: rem(30);
    height: rem(30);
}

.choose-btn {
    padding: 0 rem(16);
    height: rem(40);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: rem(20);
    margin-left: rem(10);
    border: 1px solid #e5e5e5;
    color: #999;
    font-size: rem(24);
    cursor: pointer;
}
.choose-btn:hover{
    color: #12b7f5;
}

.choose-btn--status {
    min-width: rem(108);
}

.choose-btn.active {
    color: #12b7f5;
    border: 1px solid #12b7f5;
}

.left-10 {
    margin-left: rem(10);
}

.right-10 {
    margin-right: rem(10);
}

.stu-no {
    border-radius: rem(8);
    border: 1px solid #999;
    color: #262626;
    font-size: rem(26);
    padding: rem(2) rem(6);
    margin-right: rem(10);
}

.top-img {
    width: rem(64);
    height: rem(28);
    margin-left: rem(10);
}

.top-10 {
    margin-top: rem(10);
}

.top-20 {
    margin-top: rem(20);
}

.text-22-99 {
    font-size: rem(22);
    color: #999;
}

.icon-buqian {
    width: rem(52);
    height: rem(26);
    margin-left: rem(10);
}

.icon-edit {
    width: rem(30);
    height: rem(30);
    margin-right: rem(10);
}

.icon-40 {
    width: rem(40);
    height: rem(40);
}

.like-img {
    width: rem(40);
    height: rem(40);
}

.like-text {
    font-size: rem(28);
    color: #999;
    margin-left: rem(5);
}

.record-actions {
    align-items: center;
}

.record-actions__left {
    align-items: center;
}

.record-action-entry {
    position: relative;
}

.record-actions__like {
    align-items: center;
    min-width: rem(44);
    justify-content: flex-end;
    cursor: pointer;
}

.remark-list {
    display: flex;
    flex-direction: column;
    background-color: #fff9ed;
    margin-top: rem(20);
}

.remark {
    position: relative;
    display: flex;
    flex-direction: column;
    padding: rem(10) rem(30);
}

.remark-name {
    font-size: rem(28);
    color: #262626;
}

.remark-time {
    margin-top: rem(10);
    font-size: rem(20);
    color: #999;
}

.remark-content {
    margin-top: rem(10);
    font-size: rem(26);
    color: #262626;
    margin-bottom: rem(20);
}

.audio-box {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: rem(130);
    margin-top: rem(10);
    margin-right: rem(15);
    padding: rem(10) rem(8);
    border-radius: rem(8);
    background-color: #12b7f5;
}

.audio-img {
    width: rem(21);
    height: rem(28);
    margin-right: rem(10);
    margin-left: rem(10);
}

.audio-duration {
    font-size: rem(30);
    color: #fff;
}

.remark-img {
    position: absolute;
    right: rem(20);
    top: rem(20);
    width: rem(100);
    height: rem(100);
}

.comment-list {
    padding: rem(20);
    background-color: #f2f2f7;
    margin-top: rem(10);
    text-align: left;
}

.comment-item {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.comment-item-text {
    margin-top: rem(10);
    font-size: rem(26);
    color: #262626;
    word-break: break-all;
}

.comment-item-content {
    flex: 1;
    white-space: pre-wrap;
}

.comment-list .flex-row {
    align-items: flex-start;
    justify-content: flex-start;
}

.look-all-comment {
    font-size: rem(28);
    color: #12b7f5;
    padding-bottom: rem(10);
}

.checkin-text {
    margin-bottom: rem(10);
    color: #262626;
    font-size: rem(30);
    white-space: normal;
    word-break: break-all;
}

.video-list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.video-item {
    margin-top: rem(10);
}

.audio-list {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
}

.audio-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-right: rem(15);
    margin-top: rem(10);
}

.address-box {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.address-icon {
    width: rem(48);
    height: rem(48);
    margin-right: rem(10);
}

.address-text {
    flex: 1;
    font-size: rem(26);
    color: #262626;
}

.step-box {
    display: inline-block;
    height: rem(60);
    background-color: #666;
    height: rem(60);
    border-radius: rem(30);
}

.step-box-content {
    padding: 0 rem(20);
    height: rem(60);
    border-radius: rem(30);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.step-text {
    font-size: rem(26);
    color: #fff;
}

.step-icon {
    width: rem(26);
    height: rem(26);
}

.empty-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: rem(20);
    font-size: rem(28);
    color: #999;
}
.empty-img{
    width: rem(200);
    height: rem(200);
    display: block;
    margin: rem(30) auto rem(20);
    margin-bottom: rem(20);
}

.text-28-33 {
    font-size: rem(28);
    color: #333;
    line-height: rem(88);
}

.checkin-time {
    font-size: rem(22);
    color: #999;
}

.audio-inline {
    width: rem(300);
    margin-top: rem(8);
}

.eval-dialog-popup {
    background: transparent;
}

.record-date-popup .van-datetime-picker {
    width: 100%;
}

.eval-dialog {
    background: #fff;
    border-radius: rem(30) rem(30) 0 0;
    padding: rem(34) rem(30) calc(env(safe-area-inset-bottom) + #{rem(28)});
    box-sizing: border-box;
}

.eval-title {
    text-align: center;
    font-size: rem(36);
    font-weight: 600;
    color: #2f2f2f;
    margin: rem(30) 0 rem(40);
}

.eval-levels {
    display: flex;
    flex-wrap: wrap;
    gap: rem(20);
}

.level-btn {
    width: calc((100% - #{rem(100)}) / 4);
    height: rem(62);
    line-height: rem(62);
    text-align: center;
    border-radius: rem(10);
    border: 1px solid #d5d8dd;
    background: #f5f6f8;
    color: #8f939a;
    font-size: rem(28);
    font-weight: 500;
}

.level-btn.active {
    background: #ecf7ff;
    border-color: #29abe2;
    color: #29abe2;
}

.eval-actions {
    display: flex;
    justify-content: center;
    gap: rem(24);
    margin-top: rem(40);
}

.btn-cancel,
.btn-confirm {
    width: rem(210);
    height: rem(84);
    line-height: rem(84);
    text-align: center;
    border-radius: rem(14);
    font-size: rem(28);
    font-weight: 600;
    cursor: pointer;
}

.btn-cancel {
    background: #f5f6f8;
    color: #29abe2;
}

.btn-confirm {
    background: #29abe2;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/RecordList.vue